{
  "loading": "Načítava sa...",
  "placeholder": "Vybrať…"
}
